function storeCartFormNumberofItems () {
  let valueFields = document.getElementsByClassName('store-cart-form-numberofItems-input');
  let minusSigns = document.getElementsByClassName('store-cart-form-numberofItems-minus');
  let plusSigns = document.getElementsByClassName('store-cart-form-numberofItems-plus');

  for ( let i = 0; i < valueFields.length; i++ ) {
    minusSigns[i].addEventListener( 'click', function () { valueFields[i].value != valueFields[i].min ? valueFields[i].value-- : valueFields[i].value} );
    plusSigns[i].addEventListener( 'click', function () { valueFields[i].value != valueFields[i].max ? valueFields[i].value++ : valueFields[i].value} );

  } 
}

storeCartFormNumberofItems();